/**
 * 目录全文数字调节滑块组件
 */
import React from 'react';

interface OutlineWordCountSliderProps {
  globalWordCount: number;
  min?: number;
  max?: number;
  step?: number;
  onWordCountChange: (value: number) => void;
}

const OutlineWordCountSlider: React.FC<OutlineWordCountSliderProps> = ({
  globalWordCount,
  min = 30000,
  max = 3000000,
  step = 500,
  onWordCountChange,
}) => {
  return (
    <div className="mb-4 px-2 py-3 bg-gray-50 rounded-lg border border-gray-200">
      <div className="flex items-center justify-between mb-1">
        <label className="text-xs font-medium text-gray-600">全文字数调节</label>
        <span className="text-xs text-gray-400">
          拖动滑块按比例调整各章节字数
        </span>
      </div>
      <div className="flex items-center space-x-3">
        <span className="text-xs text-gray-400 w-16 text-right">
          {min.toLocaleString()}
        </span>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={globalWordCount}
          onChange={(e) => onWordCountChange(parseInt(e.target.value))}
          className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
        />
        <span className="text-xs text-gray-400 w-20">
          {max.toLocaleString()}
        </span>
        <input
          type="number"
          value={globalWordCount}
          onChange={(e) => {
            const val = parseInt(e.target.value);
            if (!isNaN(val) && val >= min) {
              onWordCountChange(val);
            }
          }}
          className="w-20 px-2 py-1 border border-gray-300 rounded text-sm text-center"
          min={min}
        />
        <span className="text-xs text-gray-500">字</span>
      </div>
    </div>
  );
};

export default OutlineWordCountSlider;
